import { bunja } from 'bunja';
import { atom } from 'jotai';

import { authBunja } from '@flipster/features/src/shared/auth/state';

export const earnPageBunja = bunja(() => {
  const { userAtom } = bunja.use(authBunja);

  const hasFirstDepositAtom = atom((get) => {
    const user = get(userAtom);
    return !!user?.firstDepositAt;
  });

  return {
    hasFirstDepositAtom,
  };
});
earnPageBunja.debugLabel = 'earnPageBunja';
